module.exports = __webpack_public_path__ + "static/media/instructions_spike.5a45cc6a.PNG";